import Vue from 'vue'
import * as Sentry from "@sentry/vue";
import { sync } from 'vuex-router-sync'
import axios from 'axios';
import axiosDefaults from 'axios/lib/defaults';

import ImageUploader from 'vue-image-upload-resize'

import App from './App.vue'
import router from './router'
import store from './store'

import './assets/tailwind.css'

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    Vue,
    dsn: 'https://e2f1ff4468c395c98379e93a360cf84f@o4511235013476352.ingest.de.sentry.io/4511235352559696',
    tracesSampleRate: 0.2,
    sendDefaultPii: false,
    ignoreErrors: [
      // Tawk.to
      /_Tawk\.i18next is not a function/,
      /Cannot convert undefined or null to object/,
      /undefined is not an object \(evaluating 'Object\.keys\(t\)'\)/,

      // Network / browser connection errors
      /^Network Error$/,
      /^Request aborted$/,
      /^timeout of 0ms exceeded$/,
      /^Non-Error promise rejection captured with value: Network Error$/,
      /^Non-Error promise rejection captured with value: timeout of 0ms exceeded$/,

      // WebSocket errors
      /WebSocket/i,
    ],
  });
}

window.tbs = {
  googleApiKey: 'AIzaSyC2NPyeuXlOPNAgub5yoLlCBWa5N9D6IZQ', //TBS official (original)
  recaptchaSiteKey: "6Ldp8MoZAAAAABxjylgjXdNZccxftDykLVeOKHoW", //https://www.google.com/recaptcha/admin/site/432730217/setup

  // Used for: 
  // - showing stats url when creating broadcast
  // E>G>: http://78.46.109.144:3001/stats/1092133
  isTestMode: false, 
  genericKey: 'L3TwTa7U5HpjsTFoMtRsw3yYchAq9i1n7PtiRjVK'
}

const baseURL = process.env.NODE_ENV === "development" ? "http://localhost:3000" : location.origin;

console.log("process.env.NODE_ENV", process.env.NODE_ENV)
axiosDefaults.baseURL = baseURL;
axiosDefaults.headers = { 
  'Cache-Control': 'no-cache',
};
// return non-200 codes in then instead of throw
// See: https://github.com/axios/axios/issues/41
axiosDefaults.validateStatus = function () {
  return true;
};

// When response contains 'updateUser'-header -> use it's value (stringified usetr object) to update the user
// User-object may also contain a special object of form:  
axios.interceptors.response.use(resp => {
  if(resp.headers['x-updated-user']){
    const user = JSON.parse(decodeURI(resp.headers['x-updated-user']))
    store.commit("updateUser", user)
  }
  return resp;
}, (error) => {
  return Promise.reject(error.message);
});


Vue.prototype.$http = axios;
Vue.prototype.$baseURL = baseURL;
Vue.config.productionTip = false

Vue.use(ImageUploader);

// Sync state of router into vuex store
sync(store, router);

new Vue({
  router,
  store,
  render: h => h(App),
  // methods: {
  //   async recaptcha(action = null) {
  //     // (optional) Wait until recaptcha has been loaded.
  //     await this.$recaptchaLoaded()
 
  //     // Execute reCAPTCHA with action "login".
  //     const token =  await this.$recaptcha(action)
  //     console.log("token", token);
  //     return token;
  //   }
  // },
}).$mount('#app')


// One-time reload flag
const isReloading = sessionStorage.getItem("app-bundle-failed");

function reloadOnce() {
  if (!isReloading) {
    sessionStorage.setItem("app-bundle-failed", "true");
    console.log("Main app bundle failed to load. Reloading...");
    window.location.reload(); // triggers only once per session
  }
}

// Catch script loading errors
window.addEventListener(
  "error",
  (event) => {
    const target = event.target || {};
    if (target.tagName === "SCRIPT" && target.src) {
      // Only reload if the failing script is the main app bundle
      if (/\/app\..*\.js$/.test(target.src)) {
        reloadOnce();
      }
    }
  },
  true // important: use capture so script errors are caught
);
